export const RETURNS_SET_ALLOWED_METHODS = 'RETURNS_SET_ALLOWED_METHODS'
export const RETURNS_SET_INCOMING_PARCEL = 'RETURNS_SET_INCOMING_PARCEL'
export const RETURNS_SET_RETURN_SHIPPING_METHOD_ERROR = 'RETURNS_SET_RETURN_SHIPPING_METHOD_ERROR'
export const RETURNS_SET_STATIC_DATA = 'RETURNS_SET_STATIC_DATA'
